import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteTaskRepositoryProps extends ModalEditComponentProps { }

const ModalDeleteTaskRepository: React.FC<ModalDeleteTaskRepositoryProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/task/repository/deleteTaskRepository',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteIssueOfRepository', '¿Seguro que quieres eliminar este tema del repositorio?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteTaskRepository